import React from 'react';
import { ExternalLink, Clock, BarChart3 } from 'lucide-react';
import { useLang } from '../../context/LanguageContext';

export const TICKMILL_REF_URL =
  'https://my.tickmill.com?utm_campaign=ib_link&utm_content=IB35900813&utm_medium=Open+Account&utm_source=link&lp=https%3A%2F%2Fmy.tickmill.com%2Fru%2Fsign-up%2F';
export const TMSOCIAL_URL =
  'https://stats.tmsocial.net/widgets/ratings/6694?widgetKey=social_platform_ratings&lang=en&preview=P3U9YzM2ZDk2JmE9MTExNTQmcD02Njk0Jnc9MQ==';
// Temporarily disabled (13.10.2026) — user will provide a new link. To re-enable:
// set STATS_ENABLED = true, STATS_URL = '#stats', COPY_URL = TMSOCIAL_URL (or the new URL).
export const STATS_ENABLED = false;
export const STATS_URL = '';
export const COPY_URL = '';
export const SUPPORT_URL = 'https://t.me/AlefTradersSupport';
export const REFERRAL_ENABLED = false;
export const hideReferral = (items) => items.filter((x) => REFERRAL_ENABLED || !x.ref);

export function ActionLink({ href, label, testId, variant = 'primary', big = false }) {
  const { t } = useLang();
  const size = big ? 'px-10 py-5 text-lg' : 'px-7 py-4 text-base';
  const base = `inline-flex items-center justify-center gap-2 rounded-lg font-semibold transition-all duration-300 ${size}`;

  if (!href) {
    return (
      <span
        data-testid={testId}
        title={t('dcapital.soonHint')}
        aria-disabled="true"
        className={`${base} cursor-not-allowed border border-dashed border-slate-600 text-slate-400 bg-slate-800/40`}
      >
        <Clock className="w-5 h-5" />
        {label} · {t('dcapital.soon')}
      </span>
    );
  }

  const styles =
    variant === 'primary'
      ? 'bg-green-500 text-white hover:bg-green-400 hover:shadow-[0_0_40px_rgba(34,197,94,0.5)] hover:-translate-y-0.5 active:scale-[0.98]'
      : variant === 'light'
      ? 'bg-white text-green-700 hover:bg-green-50 hover:shadow-[0_0_45px_rgba(255,255,255,0.35)] hover:-translate-y-0.5 active:scale-[0.98]'
      : 'border border-slate-600 text-slate-100 hover:border-blue-500/60 hover:text-blue-300 hover:-translate-y-0.5 active:scale-[0.98]';

  const internal = href.startsWith('#');
  return (
    <a
      data-testid={testId}
      href={href}
      target={internal ? undefined : '_blank'}
      rel={internal ? undefined : 'noopener noreferrer'}
      className={`${base} ${styles}`}
    >
      {internal ? <BarChart3 className="w-5 h-5" /> : <ExternalLink className="w-5 h-5" />}
      {label}
    </a>
  );
}
